import storageUtil from '@zet/utils/storage'

const useSpecificCategory = () => {
  const category = storageUtil.getObject('category')

  return { category }
}

export { useSpecificCategory }
